import { company } from '~/company/Company';
import CategoriesGridOneSBlock from '~/components/CategoryBlocks/CategoriesGridOneSBlock/CategoriesGridOneSBlock';
import { createCategoryUrl } from '~/components/CategoryBlocks/utils';
import { CategoriesGrid1S } from '~/components/isolated/CategoryBlocks/CategoriesGrid1S';
import { useGlobal } from '~/hooks/useGlobal';
import type { Category } from '~/stores/CategoriesStore';

const CategoriesGridOneSBlockFactory = ({
  category,
  masked,
  externalLink,
  legacy,
  priority,
}: {
  category: Category;
  masked: boolean;
  externalLink?: string;
  /** Force the legacy (non-V3) block design even on V3 companies */
  legacy?: boolean;
  /** This block renders first on the page, so its leading image is not lazy */
  priority?: boolean;
}) => {
  const { isMobile } = useGlobal();

  if (company.newDesignSystemEnabled && !legacy) {
    return <CategoriesGrid1S category={category} priority={priority} />;
  }

  const items = category.subcategory.map(({ name, previewImage, id }) => ({
    title: name,
    img: previewImage,
    id,
  }));

  return (
    <CategoriesGridOneSBlock
      items={items}
      title={category.name}
      description={category.previewText}
      backgroundColor={category.backgroundColor}
      link={externalLink ?? createCategoryUrl({ id: category.id })}
      isMobile={isMobile}
      tileMaskIncluded={masked}
    />
  );
};

export default CategoriesGridOneSBlockFactory;
